/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from "@angular/core";
import { ApiService } from "@app/@core/services/api";

@Injectable()
export class AdminSettingsService {
  constructor(private apiService: ApiService) {}

  store(type, data) {
    return this.apiService.post("admin/settings/" + type, data);
  }

  update(type, uuid, data) {
    return this.apiService.post("admin/settings/" + type + "/" + uuid, data);
  }

  delete(type, uuid) {
    return this.apiService.delete("admin/settings/" + type + "/" + uuid);
  }
}
